import * as React from "react"

import { cn } from "@/lib/utils"

/* The system's loading indicator: the authored dashed-circle glyph at the status cadence,
 * always paired with a visible label and announced politely. */
function Spinner({
  label,
  className,
  ...props
}: React.ComponentProps<"div"> & { label: string }) {
  return (
    <div
      data-slot="spinner"
      className={cn("flex items-center gap-3 text-ink-soft", className)}
      role="status"
      aria-live="polite"
      {...props}
    >
      <svg className="animate-spin-status" width="20" height="20" viewBox="0 0 24 24" aria-hidden="true">
        <circle
          cx="12"
          cy="12"
          r="9"
          fill="none"
          stroke="currentColor"
          strokeWidth="2.5"
          strokeDasharray="42 100"
          strokeLinecap="round"
        />
      </svg>
      <span className="text-sm font-semibold">{label}</span>
    </div>
  )
}

export { Spinner }
